import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCity = async (params: object) => {
  return await GET({
    url: Api.getCity,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const submitCity = async (params: object) => {
  return await POST({
    url: Api.submitCity,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
